/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TagNameModalState {
    isOpen: boolean;

    data: {
        id: number;

        name: string;

        documentId: number;
    } | null;
}

export interface TagNameModalDispatchParams {
    id: number;

    name: string;

    documentId: number;
}

const initialState: TagNameModalState = {
    isOpen: false,
    data: null,
};

export const tagNameModalSlice = createSlice({
    name: 'tag-name-modal',
    initialState,
    reducers: {
        open(state: TagNameModalState, action: PayloadAction<TagNameModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: TagNameModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
